import React, { useMemo } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import usePagination from 'src/hooks/usePagination'
import { makeStyles } from '@material-ui/core'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import { ChevronRight, ChevronLeft } from '@material-ui/icons'
import Submit from './Submit'

const useStyles = makeStyles(() => ({
  root: {
    margin: '10px 0',
  },
  button: {
    backgroundColor: '#efd684',
    borderRadius: 8,
    padding: '2px 16px',
    '&:hover': {
      backgroundColor: '#efb584',
    },
  },
}))

export default function Pagination({
  totalHits = 0,
  noPaginationNumber = false,
  withSubmit = false,
  ...res
}) {
  const navigate = useNavigate()
  const classes = useStyles()
  const location = useLocation()

  console.log({ location })

  const { userExamId } = useParams()
  // const [first, after] = usePagination(40, 0)
  const [first, after] = usePagination(+userExamId === 99 ? 45 : 40, 0)

  const next = () => {
    const nextAfter = after + first < totalHits ? after + first : after
    navigate(`${location.pathname.split('/exam/')[0]}/exam/${userExamId}/${first}/${nextAfter}`)
  }

  const back = () => {
    const nextAfter = after + first > 0 ? after - first : 0
    navigate(`${location.pathname.split('/exam/')[0]}/exam/${userExamId}/${first}/${nextAfter}`)
  }

  const [pageNumber, totalPage] = useMemo(() => {
    const total = totalHits % first ? parseInt(totalHits / first, 10) + 1
      : parseInt(totalHits / first, 10)
    const page = parseInt((after / first) + 1, 10)
    return [page, total]
  }, [first, after, totalHits])

  return (
    <Grid container justify="space-between" className={classes.root}>
      <Grid item>
        <Button
          disabled={first - after > 0}
          color="primary"
          variant="contained"
          onClick={back}
          startIcon={<ChevronRight />}
          className={classes.button}
        >
          قبلی
        </Button>
      </Grid>

      {!noPaginationNumber && (
        <Grid item>
          {`صفحه ${pageNumber} از ${totalPage}`}
        </Grid>
      )}

      <Grid item>
        <Button
          disabled={after + first >= totalHits}
          color="primary"
          variant="contained"
          onClick={next}
          endIcon={<ChevronLeft />}
          className={classes.button}
        >
          بعدی
        </Button>
      </Grid>
      {(withSubmit && (after + first >= totalHits)) && <Submit {...res} />}
    </Grid>
  )
}
